// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: true,
  env: 'demo',
  api_root: 'https://api.demo.isupplier.fr/',
  superset_root: 'https://bi.demo.isupplier.fr'
};
